import React from "react";
import { useSnackbar } from "notistack";
import { Button, IconButton, InputAdornment } from "@mui/material";
import { useSelector } from "react-redux";
import FileUploadIcon from "@mui/icons-material/CloudUploadOutlined";

import { fText } from "shared/ui/Editors";
import { TooltipR } from "shared/ui/ToolBar";
import { ActionDialog, ContourBackdrop } from "shared/ui";

const UPLOAD_INPUT_ID = "upload-indicator-file-input";
const BASE_FIELD_PROPS = {
  fullWidth: true,
  style: "compact",
  size: "small",
};

function IndicatorUpload({ onOk, title }) {
  const { enqueueSnackbar } = useSnackbar();
  const api = useSelector(state => state.API);

  const [fileData, setFileData] = React.useState({ filename: "", file: null });
  const [loading, setLoading] = React.useState(false);
  
  const handleFileSelect = React.useCallback(() => {
    const input = document.getElementById(UPLOAD_INPUT_ID);
    input.value = "";
    input.click();
  }, []);

  const handleFileSelected = React.useCallback((event) => {
    const file = event.target.files[0];
    if (!file) return;
    setFileData(fileData => {
      const newFile = { ...fileData };
      newFile.filename = file.name;
      newFile.file = file;
      return newFile;
    })
  }, []);

  const handleSendClick = React.useCallback(async () => {
    const payload = new FormData();
    payload.append("token", api.token);
    payload.append("file", fileData.file);
    
    setLoading(true);
    const response = await fetch(process.env.REACT_APP_API + "/indicator/upload", { method: "POST", body: payload }).then((res) => res.json());
    
    if (!response || response?.error || response?.message) {
      enqueueSnackbar(response?.message || "Ошибка", { variant: "error" });
      setLoading(false);
      return;
    }

    enqueueSnackbar("Готово", { variant: "success" });
    onOk();
  }, [api, enqueueSnackbar, fileData, onOk]);

  if (loading) return <ContourBackdrop />;

  return (
    <ActionDialog onClose={onOk} open title={title}>
      {fText({ ...BASE_FIELD_PROPS, value: fileData, onChange: null }, "Файл для загрузки", "filename", null, {
        type: "text",
        disabled: true,
        endInputAdornment: (
          <InputAdornment style={{ position: "absolute", right: 1 }} position="end">
            <TooltipR text="Выбрать файл">
              <IconButton style={{ borderRadius: 0, borderLeft: "1px solid #ededed" }} size="small" onClick={handleFileSelect}>
                <FileUploadIcon style={{ width: 22, height: 22 }} />
              </IconButton>
            </TooltipR>
          </InputAdornment>
        ),
      })}
      <input
        id={UPLOAD_INPUT_ID}
        type="file"
        onChange={handleFileSelected}
        style={{ display: "none" }}
        accept="application/json, text/csv, text/xml, application/vnd.ms-excel"
      />
      <div style={{ display: "flex", justifyContent: "right", marginTop: 5 }}>
        <Button disabled={!fileData.file} onClick={handleSendClick} variant="contained">Загрузить</Button>
      </div>
    </ActionDialog>
  );
}

export default React.memo(IndicatorUpload);
